<template>
    <v-container>
        <v-card class="pa-16">
            <v-row>
                <v-col cols="12" md="6">
                    <v-card-title class="text-h5">Leave Type</v-card-title>
                </v-col>
                <v-col align="right" color="primary" cols="12" md="6">
                    <v-btn @click="opendialogAdd" color="#0A7EA5" rounded dark class="mb-2" v-if="authorize_add">
                        <span>Add</span>
                        <v-icon small center>add</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field
                    class="widthsizesearch"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-end mb-6">
                </v-col>
            </v-row>
    
            <br />
    
            <v-card outlined tile class="mt-2">
                <v-data-table
                    dense
                    :search="search"
                    :headers="headers"
                    :items="mDataArray"
                    class="elevation-1   595959"
                >
                    <template v-slot:[`item.actions`]="{ item }" > 
                        <v-icon
                            v-if="authorize_edit && item.leave_type != 'Vacation Leave'"
                            :style="{
                                backgroundColor: '#E1F5FE',
                                color: '#254E58',
                            }"
                             @click="openeditItem(item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                            class="ml-5"
                            :style="{
                                backgroundColor: '#FFEBEE',
                                color: '#9E3B1B',
                            }"
                            @click="deleteItem(item.id)"
                            v-if="authorize_del && item.leave_type != 'Vacation Leave'"
                            >
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
        </v-card>
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
            <v-card-title class="text-h5"
                >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
                >
                <v-spacer></v-spacer>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddData" max-width="500px">
          <v-card>
            <br />
            <v-card-title class="text-h6">New Leave Type</v-card-title>
            <v-card-text>
              <v-container>
                <v-row justify="space-around" class="heightsize70formadvance">
                  <v-col cols="12" sm="12" md="12">
                    <h3>Leave Name</h3>
                    <v-text-field
                        ref="leave_type"
                        v-model="leave_type"
                        outlined
                        dense
                    ></v-text-field>
                  </v-col>
                </v-row>
  
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                width="100"
                class="mr-3 buttonblue"
                @click="saveaddItem()"
              >
                Save
              </v-btn>
              <v-btn depressed outlined width="100" @click="closeaddItem()">
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <br />
          </v-card>
        </v-dialog>
        <SuccessDialog
            :status="dialogAdd"
            :text_color="text_color"
            :title="title"
            :message="message"
        />
    
        <SuccessDialogPush
            :status="dialogAdd"
            :text_color="text_color"
            :title="title"
            :message="message"
            :link="link"
        />
    </v-container>
  </template>
  
  
<script>
    import SuccessDialog from "@/components/cards/SuccessDialog";
    import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
    import api from "@/services/api";
    import { server } from "@/services/constants";
    
    export default {
        name: "SO-list",
        data(vm) {
            return {
                mode_oper: "",
                dialogAddData: false,
                dialogAdd: false,
                text_color: "text-h5 green--text text-center",
                title: "green",
                message: "green",
                link: "",
                id_del: 0,
                search: "",
                leave_type: "",
                dialogDelete: false,
                authorize_view: false,
                authorize_add: false,
                authorize_edit: false,
                authorize_del: false,
                toggleEnable: false,
                selectstatus: "",
                mDataArray: [],
                authorize: [],
                headers: [
                    {
                        text: "Title",
                        value: "leave_type",
                        class: "bg-colorth tabletextwhite",
                        align: "start",
                        divider: true,
                    },

                    {
                        text: "",
                        value: "actions",
                        align: "center",
                        class: "bg-colorth tabletextwhite",
                        divider: true,
                    },
                ],
                leave_type_old: ""
            };
            },
        async beforeCreate() {
            console.log("beforeCreate");
            this.$store.state.navMenu = true ;
        },
        beforeUpdate() {},
        components: {
            SuccessDialog,
            SuccessDialogPush,
        },
        computed: {
            itemsForSelected() {
                if (this.search.length) {
                    return this.dataSource.filter((item) => this.search.includes(item));
                }
                return this.dataSource;
            },
        },
        async mounted() {
            await api.checkVersion();
            this.userId = localStorage.getItem(server.USER_ID);
            let yourUrlString = window.location;
            // alert(yourUrlString);
        
            let parser = document.createElement("a");
            parser.href = yourUrlString;
        
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
        
            // alert("authorize_id:" + this.authorize_id);
            if (this.authorize_id == null || this.authorize_id == 0) {
                // this.$router.push("/login");
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                true,
                "Authorize Failed!!!",
                "Please Logout And Login Again!!!",
                "text-h5 red--text text-center"
                );
                this.$router.back();
            }
        
            const router_path = parser.pathname.replace("/", "");
        
            const res_auth = await api.getAuthorize(this.userId, router_path);

        
            this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
            this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
            this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
            this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
        

        
            if (!this.authorize_view) {
                this.$router.back();
            }
        
            // ----------------- Check Authorize ---------------------------
        
            let comp_id = localStorage.getItem(server.COMPANYID);
        
            this.userId = localStorage.getItem(server.USER_ID);
            if (this.userId && api.isLoggedIn()) {
                // this.$router.push("/");
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
            }

            //load data
            await this.loaddata();
            this.$hideLoader();
        },
        methods: {
            async loaddata() {
                const res_result = await api.getLeaveTypeAll(localStorage.getItem(server.COMPANYID))  
                this.mDataArray = res_result.data;
                console.log(this.mDataArray)
            },
            async opendialogAdd(id){
                this.mode_oper = "Add";
                this.leave_type = "";
                this.dialogAddData = true;
            },
            async saveaddItem(){
                if (this.leave_type == "") {
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                    true,
                    "Check your information again",
                    "Please enter all the details.",
                    "text-h5 red--text text-center"
                    );
                    this.$refs["leave_type"].focus();
                    return;
                }
                
                //check leave ซ้ำ
                const filteredDataLeave = this.mDataArray.filter(item => item.leave_type === this.leave_type);
                if(this.mode_oper == "Add"){
                    if(filteredDataLeave.length > 0){
                        this.$store.state.global_dialog = true;
                        this.setupAlertDialog(
                        true,
                        "Check your information again",
                        "This Leave Type is already in use, Please enter all the details.",
                        "text-h5 red--text text-center"
                        );
                        this.$refs["leave_type"].focus();
                        return;
                    }
                }else if(this.mode_oper == "Edit"){
                    if(this.leave_type != this.leave_type_old){
                        if(filteredDataLeave.length > 0){
                            this.$store.state.global_dialog = true;
                            this.setupAlertDialog(
                            true,
                            "Check your information again",
                            "This Leave Type is already in use, Please enter all the details.",
                            "text-h5 red--text text-center"
                            );
                            this.$refs["leave_type"].focus();
                            return;
                        }
                    }
                }else{
                    return;
                }

                this.$showLoader()
                var res_oper = [];
                if(this.mode_oper == "Add"){
                    var dataitem_add = {
                        leave_id: 0,
                        leave_type: this.leave_type,
                        company_id: Number(localStorage.getItem(server.COMPANYID))
                    }
                     res_oper = await api.createLeaveType(dataitem_add)
                }else if(this.mode_oper == "Edit"){
                    var dataitem_edit = {
                        leave_type: this.leave_type,
                    }

                    res_oper = await api.updateLeaveType(this.id_del,dataitem_edit)
                }
                if(res_oper.status == 201){
                        this.dialogAddData = false
                        await this.loaddata();
                        this.$hideLoader();
                        this.$store.state.global_dialog = true;
                        this.setupAlertDialog(
                            true,
                            "Success",
                            "Data successfully added",
                            "text-h5 green--text text-center",
                        );
                    }else{
                        this.$hideLoader();
                        this.$store.state.global_dialog = true;
                        this.setupAlertDialog(
                            true,
                            "ลบข้อมูล!!!",
                            "ไม่สามารถลบได้!!!",
                            "text-h5 red--text text-center"
                        );
                    }
            },
            async closeaddItem(){
                this.dialogAddData = false;
                this.leave_type_old = "";
            },
            async openeditItem(data){
                this.id_del = 0;
                this.id_del = data.id;
                this.mode_oper = "Edit";
                this.leave_type = data.leave_type;
                this.leave_type_old = data.leave_type;
                this.dialogAddData = true ;
                
                // this.$router.push(`/invioce-title-add/Edit/${id}`);
            },
            async deleteItem(id){
                this.id_del = 0;
                this.id_del = id;
                this.dialogDelete = true;
            },
            async deleteItemConfirm(){
                this.dialogDelete = false;
                this.$showLoader();
                const res_del = await api.deleteLeaveType(this.id_del);
                if(res_del.status == 200){
                        await this.loaddata();
                        this.$hideLoader();
                        this.$store.state.global_dialog = true;
                        this.setupAlertDialog(
                            true,
                            "Success",
                            "Data successfully deleted",
                            "text-h5 green--text text-center",
                        );
                    }else{
                        this.$hideLoader();
                        this.$store.state.global_dialog = true;
                        this.setupAlertDialog(
                            true,
                            "ลบข้อมูล!!!",
                            "ไม่สามารถลบได้!!!",
                            "text-h5 red--text text-center"
                        );
                    }
            },
            async closeDelete(){
                this.dialogDelete = false;
            },
            setupAlertDialog(status, title, message, text_color) {
                this.title = title;
                this.message = message;
                this.dialogAdd = status;
                this.text_color = text_color;
            },
            setupAlertDialogPush(status, title, message, text_color, link) {
                this.title = title;
                this.message = message;
                this.dialogAdd = status;
                this.text_color = text_color;
                this.link = link;
            },

        },
    };
</script>
  
<style scoped>
    .bg-colorth {
        background-color: #595959;
        color: red;
    }
    .text-left {
        color: aliceblue;
    }
    .widthsizesearch {
        width: 70%;
    }
    .theme--light.v-card {
        border-color: white;
    }
</style>

  